// extracted by mini-css-extract-plugin
export default {"contenedor":"error_contenedor__Px-ac","principal":"error_principal__Hv2aZ","titulo":"error_titulo__iw79s","subtitulo":"error_subtitulo__650qW","imagen":"error_imagen__E-Wsb"};